module.exports = __webpack_public_path__ + "img/1509473255.73cc8274.jpg";